var map = {
	"./de/authentication.json": 48281,
	"./de/dates.json": 99358,
	"./de/translation.json": 74344,
	"./en/authentication.json": 20357,
	"./en/dates.json": 48122,
	"./en/translation.json": 75372,
	"./fr/authentication.json": 26560,
	"./fr/dates.json": 60229,
	"./fr/translation.json": 31047
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26620;